module.exports = __webpack_public_path__ + "img/flag_jpn.573ddab2.svg";